import axios from 'axios';

const LOGIN_PATH = 'https://feedbot-api.poviolabs.com/api/login';

const LoginApi = (email = '', password = '') =>
  new Promise((resolve, reject) => {
    axios
      .post(LOGIN_PATH, { email, password }, { crossDomain: true })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        } else {
          reject(new Error('Login failed'));
        }
      })
      .catch(e => reject(e));
  });
export default LoginApi;



// WEBPACK FOOTER //
// ./src/api/LoginApi.js